import { MarkerTypeWaterActivity } from 'types/markerTypes/location-markers-type.js';

export enum OpinionatedLegendTypes {
  BBQ = 'bbq',
  Rainfall = 'rainfall',
  RainfallThreeDay = 'rainfall-3-day',
  RainfallFiveDay = 'rainfall-5-day',
  Cumulative = 'cumulative-rainfall',
  Satellite = 'satellite',
  SeaTemp = 'sea-surface-temp',
  SeaTempAnomaly = 'sea-surface-anomaly',
  WaveHeight = 'significant-wave-height',
  PeakWavePeriod = 'peak-wave-period',
  WeatherStations = 'weather-stations',
  WarningSeverity = 'warning-severity',
  CloudPatternRange = 'cloud-pattern-range',
  SurfacePressure = 'surface-pressure',
  SoilMoistureKey = 'soil-moisture-key',
  SoilTemperatureKey = 'soil-temperature-key',
}

export const LegendTypes = {
  ...OpinionatedLegendTypes,
  ...MarkerTypeWaterActivity,
};

/** Merge types into Legend Types */
export type LegendTypes = `${(typeof LegendTypes)[keyof typeof LegendTypes]}`;

export enum LegendsEnum {
  Keys = 'Keys',
  Filters = 'Filters',
}

export const hasLegend = (...items: (Array<unknown> | undefined)[]): boolean => {
  const totalItems = items.reduce((acc, item) => {
    return acc + (item?.length ?? 0);
  }, 0);
  return totalItems > 0;
};
